export const ACE_EDITOR_DEFAULT_PROPS = {
  className: 'aceTheme',
  fontSize: 14,
  lineHeight: 19,
  showGutter: true,
  showPrintMargin: false,
  wrapEnabled: true,
  highlightActiveLine: false,
  width: '100%',
};

export const ACE_EDITOR_DEFAULT_OPTIONS = {
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false,
  enableSnippets: false,
  showLineNumbers: true,
  useWorker: false,
  tabSize: 2,
  foldStyle: 'manual',
  showFoldWidgets: false,
  displayIndentGuides: false,
};
